import React from 'react'

import { FilterDropdown } from '@components/common/FilterDropdown'
import { Checkbox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import type { GiftCard } from '../../GiftCards.types'
import * as S from './GiftCardsFilter.styled'
import type { FormValues } from './GiftCardsFilter.types'
import { useFilterGiftCards } from './hooks/useFilterGiftCards'

const options: { label: string; value: GiftCard['status'] }[] = [
  { label: 'Unused', value: 'UNUSED' },
  { label: 'Fully used', value: 'FULLY_USED' },
  { label: 'Partially used', value: 'PARTIALLY_USED' },
  { label: 'Expired', value: 'EXPIRED' },
  { label: 'Deactivated', value: 'DEACTIVATED' },
  { label: 'Archived', value: 'ARCHIVED' },
]

export const GiftCardsFilter = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } =
    useFilterGiftCards()

  const hasStatusParam = (status: GiftCard['status']) => {
    return !!filtersParams.status?.split(',').includes(status)
  }

  const handleSubmit = (values: FormValues) => {
    const status = Object.keys(values)
      .filter((key) => values[key as GiftCard['status']])
      .join(',')

    setFiltersParams({
      status,
    })
  }

  const formik = useFormik<FormValues>({
    initialValues: {
      UNUSED: hasStatusParam('UNUSED'),
      FULLY_USED: hasStatusParam('FULLY_USED'),
      PARTIALLY_USED: hasStatusParam('PARTIALLY_USED'),
      EXPIRED: hasStatusParam('EXPIRED'),
      DEACTIVATED: hasStatusParam('DEACTIVATED'),
      ARCHIVED: hasStatusParam('ARCHIVED'),
    },
    enableReinitialize: true,
    onSubmit: handleSubmit,
  })

  const handleReset = () => {
    formik.resetForm()
    resetFiltersParams()
  }

  return (
    <FilterDropdown
      content={
        <S.Form>
          <S.FormRow>
            <FilterDropdown.GroupTitle title="Status" />
            {options.map((option) => (
              <Checkbox label={option.label} {...formik.getFieldProps(option.value)} />
            ))}
          </S.FormRow>
        </S.Form>
      }
      activityIndicator={hasFilterParams}
      onSubmit={formik.handleSubmit}
      onReset={handleReset}
    />
  )
}
